<div class="AMPaymenSelect_items d-flex flex-column">
  <div [ngClass]="{'font-edit': screen == 'edit','font-item': screen == 'cart'}" class="AMPaymenSelect_item" *ngFor="let item of cartItems">
    <div class="AMPaymenSelect_item--1child">
      <div class="quantity">{{ item.quantity }}</div>
      <div > {{ item.title | translate}} </div>
      <div [ngClass]="{'AMPaymenSelect_item--1child-inf': screen == 'cart'}" ></div>
      <!-- --{{item.type}} -->
    </div>
    <div class="AMPaymenSelect_item--2child">
      <div>{{ item.subtotal | amCurrency }}
      </div>
      <div>
        <span [ngClass]="{'font-edit-code': screen == 'edit','txt-currencyCodeITem':screen == 'cart' }" >{{ item.currencyCode }}</span>
      </div>
      <div>
        <!-- Aun no esta definida esta funcionalidad -->
        <!-- <span
        *ngIf="screen == 'cart'"
        class="img-chevron"><img src="../../../../../assets/images/payment/chevron-up.svg" alt=""></span> -->
        <span *ngIf="screen == 'edit'" class="img-close"> <img (click)="handleDeleteItem(item)" src="../../../../../assets/images/payment/close.svg" alt="close"></span>
      </div>
    </div>
    <div *ngIf="showDetail" class="detail-items">
      <div *ngFor="let detail of item.detail" class="detail-item d-flex flex-row justify-content-between">
        <div>{{ detail.displayName }}</div>
        <div>{{ detail.bags?.length }}</div>
      </div>
    </div>

    <!-- Aun no esta definida esta funcionalidad -->
    <!-- <div class="second-items">
      <div>
        <div [ngClass]="{'txt-secondItem-ml': screen == 'edit','font-edit-name': screen == 'edit','txt-secondItem':screen == 'cart'}" >{{namePassenger}}</div>
      </div>
      <div [ngClass]="{'font-edit-total': screen == 'edit','txt-secondItem':screen == 'cart'}">
        <div>{{ item.subtotal | currency }}
        </div>
        <div [ngClass]="{'third-items': screen == 'edit'}" >
         <span [ngClass]="{'txt-currencyCodeITem': screen == 'edit','txt-currencyCode':screen == 'cart' }" >{{ item.currencyCode }}</span>
          <span *ngIf="screen == 'edit'" class="img-close"> <img src="../../../../../assets/images/payment/close-edit-color.svg" alt="close"></span>
        </div>
      </div>
    </div> -->

  </div>
</div>
